module.exports = __webpack_public_path__ + "public/1f183e5b4cca9c5b3df80d0f26e46e89.eot";